import React from 'react';
import { Form, Input, Modal } from 'antd';
import type { FormInstance } from 'antd';
import { AttributeOptionsEditor } from './AttributeOptionsEditor';

interface CreateAttributeModalProps {
  open: boolean;
  onOk: () => Promise<void>;
  onCancel: () => void;
  form: FormInstance;
  loading?: boolean;
}

export const CreateAttributeModal: React.FC<CreateAttributeModalProps> = ({
  open,
  onOk,
  onCancel,
  form,
  loading,
}) => {
  return (
    <Modal
      title="Создать атрибут фермы"
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText="Создать"
      cancelText="Отмена"
      confirmLoading={loading}
      width={600}
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          label="Название"
          name="name"
          rules={[{ required: true, message: 'Введите название атрибута' }]}
        >
          <Input placeholder="Например, Полив" />
        </Form.Item>
        <Form.Item label="Описание" name="description">
          <Input.TextArea rows={2} placeholder="Описание атрибута" />
        </Form.Item>
        <Form.List name="options">
          {(fields, operations) => (
            <AttributeOptionsEditor
              fields={fields}
              operations={operations}
              helperText="Опции (необязательно). Перетащите карточки, чтобы изменить порядок."
              emptyText="Опции не добавлены"
              listName={['options']}
            />
          )}
        </Form.List>
      </Form>
    </Modal>
  );
};
